export default "__VITE_ASSET__bhbcW$x8__"